import { cn } from '@/shared/lib/utils';
import type { LucideIcon } from 'lucide-react';
import React from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  icon?: LucideIcon;
  actions?: React.ReactNode;
  className?: string;
}

/** 목록·상세 페이지 공통 헤더 */
export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  icon: Icon,
  actions,
  className,
}) => (
  <div
    className={cn(
      'flex flex-wrap items-start justify-between gap-4',
      className,
    )}
  >
    <div className="flex items-start gap-3">
      {Icon ? (
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-12 bg-gradient-to-br from-primary/15 to-ruda-secondary/10 text-primary ring-1 ring-primary/20">
          <Icon className="h-5 w-5" />
        </div>
      ) : null}
      <div>
        <h1 className="text-xl font-semibold tracking-tight text-foreground">
          {title}
        </h1>
        {description ? (
          <p className="mt-1 text-sm text-muted-foreground">{description}</p>
        ) : null}
      </div>
    </div>
    {actions ? (
      <div className="flex flex-wrap items-center gap-2">{actions}</div>
    ) : null}
  </div>
);
